import { Card } from "@/components/ui/card";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Award, TrendingUp } from "lucide-react";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip } from "recharts";

interface CustomerVIPProps {
  data: any[];
}

export function CustomerVIP({ data }: CustomerVIPProps) {
  const vipCustomers = data
    .map((customer) => {
      const totalSpent = customer.transactions?.reduce(
        (sum: number, transaction: any) =>
          transaction.type === "entrada" ? sum + Number(transaction.amount) : sum,
        0
      );
      const purchaseCount = customer.transactions?.filter(
        (t: any) => t.type === "entrada"
      ).length;

      return {
        ...customer,
        totalSpent,
        purchaseCount,
      };
    })
    .sort((a, b) => b.totalSpent - a.totalSpent)
    .slice(0, 10);

  const chartData = vipCustomers.map((customer) => ({
    name: customer.name,
    valor: customer.totalSpent,
  }));

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-2 text-[#0073B7]">
        <Award className="h-5 w-5" />
        <h3 className="text-lg font-semibold">Top 10 Clientes</h3>
      </div>

      <div className="rounded-lg border bg-card p-4">
        <BarChart width={600} height={300} data={chartData}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          <Bar dataKey="valor" fill="#0073B7" />
        </BarChart>
      </div>

      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Cliente</TableHead>
            <TableHead>Total Gasto</TableHead>
            <TableHead>Quantidade de Compras</TableHead>
            <TableHead>Ticket Médio</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {vipCustomers.map((customer) => (
            <TableRow key={customer.id}>
              <TableCell className="font-medium">{customer.name}</TableCell>
              <TableCell>
                {new Intl.NumberFormat("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                }).format(customer.totalSpent)}
              </TableCell>
              <TableCell>{customer.purchaseCount}</TableCell>
              <TableCell>
                {new Intl.NumberFormat("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                }).format(customer.totalSpent / customer.purchaseCount)}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}